// Abort controller for color variant fetches - prevents race conditions
let _colorFetchAbortController = null;
// Flag to indicate color variant is being resolved
window._colorVariantResolving = false;

// product variant dropdown webcomponent
class ProductVariantPicker extends HTMLElement {
  constructor() {
    super();
    this.selectedColorVariantId = null; // Track the selected color variant globally
  }

  connectedCallback() {
    this.initializeVariantSelectors();
    this.initializeColorPaletteModal();
  }

    initializeVariantSelectors() {
      this.querySelector(".color-swatches").addEventListener(
        "click",
        async (event) => {
          if (event.target.name === "Colour") {
            const matchedVariant = _ProductVariants.find((variant) => {
              return variant.options.some(
                (option) => option === event.target.value
              );
            });
            this.selectedColorVariantId = matchedVariant.id;
            const newUrl = `${window.location.pathname}?variant=${matchedVariant.id}`;
            history.replaceState({ path: newUrl }, "", newUrl);
  
            // Disable ATC button during fetch
            const submitBtn = document.querySelector('.product-form__submit');
            if (submitBtn) {
              submitBtn.disabled = true;
              submitBtn.setAttribute('aria-disabled', 'true');
            }
  
            await this.fetchAndRenderProductContent(newUrl);
  
            // Re-enable ATC button after fetch
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.removeAttribute('aria-disabled');
            }
          }
        }
      );
    }

  initializeColorPaletteModal() {
    let isVariantLoading = false;
    let closeTimeoutId = null;
    const modal = document.querySelector("#colorPaletteModal");
    const overlay = document.querySelector("#colorPaletteOverlay");
    const btn = document.querySelector("#colorPaletteButton");
    const span = document.querySelector(".color-palette-modal-content .close");
    const selectedColorText = document.querySelector("#selectedColorText");
    const colorSearch = document.getElementById("colorSearch");

    let modalState = {
      searchQuery: "",
      selectedColorName: null,
      selectedColorCard: null,
    };

    btn.addEventListener("click", (event) => {
      event.stopPropagation();
      event.preventDefault();

      if (isVariantLoading) return;

      // Clear any pending close timeout to prevent race condition
      if (closeTimeoutId) {
        clearTimeout(closeTimeoutId);
        closeTimeoutId = null;
      }
      modal.classList.remove("closing");

      // Clear any inline display:none set by other scripts
      modal.style.display = '';
      overlay.style.display = '';

      modal.classList.add("open");
      overlay.style.visibility = "visible";
      overlay.style.opacity = "1";
      modal.scrollTop = modal.scrollTop || 0;

      if (modalState.searchQuery) {
        colorSearch.value = modalState.searchQuery;
        filterColors(modalState.searchQuery);
      } else if (modalState.selectedColorName) {
        colorSearch.value = "";
        filterColors(modalState.selectedColorName);
      } else {
        filterColors("all");
      }

      if (modalState.selectedColorName) {
        const selectedSwatch = document.querySelector(
          `.color-swatch[data-color-handle="${modalState.selectedColorName}"]`
        );
        if (selectedSwatch) {
          selectedSwatch.classList.add("selected");
        }
      }
    });

    span.onclick = function () {
      closeModal();
    };

    document.addEventListener("click", function (event) {
      if (!modal.classList.contains("open")) return;
      if (!modal.contains(event.target) && !btn.contains(event.target)) {
        closeModal();
      }
    });

    function closeModal() {
      if (!modal.classList.contains("open")) return;

      modalState.searchQuery = colorSearch.value;

      const selectedSwatch = document.querySelector(".color-swatch.selected");

      modalState.selectedColorName = selectedSwatch
        ? selectedSwatch.getAttribute("data-color-handle")
        : null;

      const selectedCard = document.querySelector(".color-item.selected");

      modalState.selectedColorCard = selectedCard
        ? selectedCard.querySelector('input[type="radio"]').getAttribute("data-color-name")
        : null;

      const selectedColor = selectedCard
        ? selectedCard.querySelector(".color-card").style.backgroundColor
        : null;

      const selectedBgImage = selectedCard
  ? selectedCard.querySelector(".color-card").style.backgroundImage
  : null;

      const colorCircle = document.querySelector("#colorPaletteButton .color-circle");
      const colorPaletteIcon = document.querySelector("#colorPaletteButton .ColorPaletteIcon");

   
      if (colorCircle) {
        if (selectedBgImage && selectedBgImage !== "none" && selectedBgImage !== "") {
          // Variant has a background image
          colorCircle.style.backgroundImage = selectedBgImage;
          colorCircle.style.backgroundSize = "cover";
          colorCircle.style.backgroundPosition = "center";
          colorCircle.style.backgroundColor = "transparent";
          colorCircle.style.display = "inline-block";
          colorPaletteIcon.style.display = "none";
        } else if (selectedColor && selectedColor !== "transparent") {
          // Variant has a background color
          colorCircle.style.backgroundImage = "none";
          colorCircle.style.backgroundColor = selectedColor;
          colorCircle.style.display = "inline-block";
          colorPaletteIcon.style.display = "none";
        } else {
          colorCircle.style.display = "none";
          colorCircle.style.backgroundImage = "none";
          colorPaletteIcon.style.display = "inline-block";
        }
      }

      const colourHeading = document.querySelector(".colour-heading");

      if (colourHeading) {
        if (selectedCard) {
          colourHeading.style.display = "none";
        } else {
          colourHeading.style.display = "";
        }
      }

      modal.classList.add("closing");
      overlay.style.visibility = "hidden";
      overlay.style.opacity = "0";

      if (closeTimeoutId) {
        clearTimeout(closeTimeoutId);
      }
      closeTimeoutId = setTimeout(() => {
        modal.classList.remove("open", "closing");
        document.body.classList.remove("modal-open");
        closeTimeoutId = null;
      }, 700);
    }

    const colorSwatches = document.querySelectorAll(".color-swatch");
    Array.from(colorSwatches).forEach((swatch) => {
      swatch.onclick = function () {
        Array.from(colorSwatches).forEach((s) => s.classList.remove("selected"));
        this.classList.add("selected");

        const colorHandle = this.getAttribute("data-color-handle");
        filterColors(colorHandle);
      };
    });

    function filterColors(query) {
      const colorItems = document.getElementsByClassName("color-item");
      Array.from(colorItems).forEach((item) => {
        const colorName = item.getAttribute("data-color-handle").toLowerCase();
        const ColourSubtitle =
          item.querySelector(".color-subtitle")?.textContent.toLowerCase() || "";
        if (
          query === "all" ||
          colorName.includes(query.toLowerCase()) ||
          ColourSubtitle.includes(query.toLowerCase())
        ) {
          item.style.display = "block";
        } else {
          item.style.display = "none";
        }
      });
    }

    const colorItems = document.getElementsByClassName("color-item");
    Array.from(colorItems).forEach((item) => {
      item.onclick = async function (event) {
        const radio = this.querySelector('input[type="radio"]');
        const colorName = radio.getAttribute("data-color-name");
        const sku = this.getAttribute("data-sku");

        if (this.classList.contains("selected")) {
          radio.checked = true;
          this.setAttribute("data-selected", "true");
          return;
        }

        selectedColorText.textContent = colorName;

        radio.checked = true;
        Array.from(colorItems).forEach((i) => {
          i.classList.remove("selected");
          i.setAttribute("data-selected", "false");
        });
        this.classList.add("selected");
        this.setAttribute("data-selected", "true");

        const skuElement = document.querySelector(".product__sku span");
        if (skuElement) {
          skuElement.textContent = sku;
          skuElement.classList.remove("visibility-hidden");
        }

        const colorVariant = radio.getAttribute("data-color-variant");
        this.selectedColorVariantId = colorVariant; // Update the selected color variant globally

        const currentVariantId = new URLSearchParams(window.location.search).get("variant");
        const newUrl = `${window.location.pathname}?variant=${colorVariant}`;
        closeModal();
        if (currentVariantId !== colorVariant) {
          history.replaceState({ path: newUrl }, "", newUrl);

          isVariantLoading = true;
          btn.style.cursor = 'not-allowed';
          btn.style.opacity = '0.6';

          // Show loader spinner, hide arrow
          const loader = btn.querySelector('.color-palette-loader');
          const arrow = btn.querySelector('.arrow-button');
          if (loader) loader.style.display = 'inline-block';
          if (arrow) arrow.style.display = 'none';

          // Disable ATC button and variant selects during fetch
          const submitBtn = document.querySelector('.product-form__submit');
          if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.setAttribute('aria-disabled', 'true');
          }

          // Disable variant-selects to prevent option changes during color fetch
          const variantSelectsEl = document.querySelector('variant-selects');
          if (variantSelectsEl) {
            variantSelectsEl.querySelectorAll('select, input').forEach(el => el.disabled = true);
          }

          try {
            window._colorVariantResolving = true;
            await fetchAndRenderProductContentAll(newUrl);
          } finally {
            window._colorVariantResolving = false;

            // Re-enable ATC button after fetch
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.removeAttribute('aria-disabled');
            }

            // Re-enable variant selects
            const updatedVariantSelects = document.querySelector('variant-selects');
            if (updatedVariantSelects) {
              updatedVariantSelects.querySelectorAll('select, input').forEach(el => el.disabled = false);
            }

            isVariantLoading = false;
            btn.style.cursor = '';
            btn.style.opacity = '';

            // Hide loader spinner, restore arrow
            if (loader) loader.style.display = 'none';
            if (arrow) arrow.style.display = '';
          }
        }

        const colorValueName = radio.getAttribute("data-color-name");
        document.querySelector(".product-form").setAttribute("data-colour-value", colorValueName);
      };
    });

    colorSearch.oninput = function () {
      const filter = colorSearch.value.toLowerCase();
      filterColors(filter);
    };
  }

  async fetchAndRenderProductContent(newUrl) {
    try {
      const response = await fetch(newUrl);
      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const newProductContent = doc.querySelector(".product__info-wrapper .product__sku");
      const productContainer = document.querySelector(".product__info-wrapper .product__sku");
      if (productContainer && newProductContent) {
        productContainer.innerHTML = newProductContent.innerHTML;
        this.reinitializeProductScripts();
      }

      const newPrice = doc.querySelector('[id^="price-"]');
      const currentPrice = document.querySelector('[id^="price-"]');
      if (currentPrice && newPrice) {
        currentPrice.innerHTML = newPrice.innerHTML;
      }

      const newPriceButton = doc.querySelector('[id^="price-button-"]');
      const currentPriceButton = document.querySelector('[id^="price-button-"]');
      if (currentPriceButton && newPriceButton) {
        currentPriceButton.innerHTML = newPriceButton.innerHTML;
      }

       const variantId = new URL(newUrl, window.location.origin).searchParams.get('variant');
    if (variantId) {
      document.querySelectorAll('input[name="id"].product-variant-id').forEach((input) => {
        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    } catch (error) {
      console.error("Error fetching product content:", error);
    }
  }

  reinitializeProductScripts() {
    this.initializeVariantSelectors();
    this.initializeColorPaletteModal();
  }
}

customElements.define("product-variant-picker", ProductVariantPicker);

async function fetchAndRenderProductContentAll(url) {
  // Abort any previous in-flight color fetch to prevent race conditions
  if (_colorFetchAbortController) {
    _colorFetchAbortController.abort();
  }
  _colorFetchAbortController = new AbortController();
  const signal = _colorFetchAbortController.signal;

  try {
    const response = await fetch(url, { signal });
    if (!response.ok) {
      throw new Error(`Failed to fetch product content: ${response.statusText}`);
    }
    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const productContent = document.querySelector(".product__info-wrapper .product__sku");
    const newContent = doc.querySelector(".product__info-wrapper .product__sku");
    if (productContent && newContent) {
      productContent.innerHTML = newContent.innerHTML;
      const skuElement = document.querySelector(".product__sku");
      if (skuElement) {
        const selectedColorItem = document.querySelector(".color-item.selected");
        if (selectedColorItem) {
          const sku = selectedColorItem.getAttribute("data-sku");
          const newSku = "SKU:" + sku;
          skuElement.textContent = newSku;
          skuElement.classList.remove("visibility-hidden");
        }
      }
    }



    const inventoryContent = document.querySelector("variant-selects");
    const newInventoryContent = doc.querySelector("variant-selects");
    if (inventoryContent && newInventoryContent) {
      inventoryContent.innerHTML = newInventoryContent.innerHTML;
      reinitializeVariantSelection();

      // Trigger change event on variant-selects so product-info.js syncs the variant
      const selectedOption = inventoryContent.querySelector('select, fieldset input:checked');
      if (selectedOption) {
        selectedOption.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    const newPrice = doc.querySelector('[id^="price-"]');
    const currentPrice = document.querySelector('[id^="price-"]');
    if (currentPrice && newPrice) {
      currentPrice.innerHTML = newPrice.innerHTML;
    }

    const newPriceButton = doc.querySelector('[id^="price-button-"]');
    const currentPriceButton = document.querySelector('[id^="price-button-"]');
    if (currentPriceButton && newPriceButton) {
      currentPriceButton.innerHTML = newPriceButton.innerHTML;
    }

    const variantId = new URL(url, window.location.origin).searchParams.get('variant');
    if (variantId) {
      document.querySelectorAll('input[name="id"].product-variant-id').forEach((input) => {
        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  } catch (error) {
    if (error.name === 'AbortError') {
      console.log('Color variant fetch aborted (superseded by newer selection)');
      return;
    }
    console.error("Error fetching product content:", error);
  } finally {
    _colorFetchAbortController = null;
  }
}

function reinitializeVariantSelection() {
  const variantOptions = document.querySelectorAll("variant-selects [data-variant-option]");
  variantOptions.forEach((option) => {
    option.addEventListener("click", (event) => {
      const selectedVariantId = event.target.getAttribute("data-variant-id");
      updateSKU(selectedVariantId);
    });
  });
}

function updateSKU(variantId) {
  const skuElement = document.querySelector(".product__sku");
  const variantData = window.variantData || {};
  if (variantData[variantId]) {
    skuElement.textContent = variantData[variantId].sku;
  }
}